import { Loader, SearchInput } from "@tfg/ui"
import { noop } from "lodash"
import { useTranslation } from "react-i18next"

import { FindProductsCatalogRequestFiltersDto } from "~/gen/api"

interface Props {
  filtersValue: FindProductsCatalogRequestFiltersDto
  setFiltersValue: (filters: FindProductsCatalogRequestFiltersDto) => void
  isFetching: boolean
}

export const ProductSearch = ({
  filtersValue,
  setFiltersValue,
  isFetching,
}: Props) => {
  const { t } = useTranslation("products")

  return (
    <SearchInput
      inputValue={filtersValue.search ?? ""}
      onOpen={noop}
      delay={600}
      autoFocus
      w={180}
      placeholder={t("lists.placeholders.searchProduct")}
      onChange={(value) => {
        setFiltersValue({ ...filtersValue, search: value.toString() })
      }}
      rightSection={isFetching && <Loader size={16} />}
    />
  )
}
